import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import { UserContext } from '../UserContext';
import Footer from '../Footer';
import './StudentDashboard.css';

const StudentDashboard = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const courseId = location.state?.courseId || 0;

  const [selectedStudent, setSelectedStudent] = useState(null);
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedModule, setSelectedModule] = useState('');
  const [selectedLesson, setSelectedLesson] = useState('');
  const [studentsData, setStudentsData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [justUserId, setJustUserId] = useState(null);
  const [currentStatus, setCurrentStatus] = useState({
    currentModule: null,
    currentLesson: null
  });
  const [searchTerm, setSearchTerm] = useState('');

  async function teacherId(User_id) {
    return await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/teacherFromId/${User_id}`).then((res) => {
      res.json().then((data) => {
        axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentsDashboardByCourse/${data?.teacher_id}`)
          .then(response => {
            setStudentsData(response?.data?.courseInfo.map((item) => ({ ...item, activeCourse: 0, activeModule: 0, activeLesson: 0 })));
          })
          .catch(error => {
            console.error('Error fetching Students:', error);
          });

        axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getAllCoursesByTeacher/${data?.teacher_id}`)
          .then(response => {
            setCourses(response?.data);
          })
          .catch(error => {
            console.error('Error fetching Students:', error);
          });
        setUserId(data?.teacher_id);
      });
    });
  }

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      }).then((response) => {
        response
          .json()
          .then((userInfo) => {
            setJustUserId(userInfo?.User_id);
            teacherId(userInfo?.User_id);
          })
          .catch((err) => console.log("Error in useeffect:", err));
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/geAllModules`)
      .then((response) => {
        if (response.data.Data !== false) {
          setModules(response.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching modules:', error);
      });

    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getAllLessons`)
      .then((response) => {
        if (response.data.Data !== false) {
          setLessons(response.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching lessons:', error);
      });
  }, [userId]);

  const handleCourseChange = (value, studentId) => {
    axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getLessonActivityProfileData/${studentId}/${value}`
    ).then((response) => {
      const moduleId = response.data.data?.Module_id || null;
      const lessonId = response.data.data?.Lesson_id || null;

      const updatedStudentData = studentsData.map((student) => {
        if (student.studentId === studentId) {
          return {
            ...student,
            activeCourse: parseInt(value),
            activeModule: moduleId,
            activeLesson: lessonId
          };
        }
        return student;
      });
      setStudentsData(updatedStudentData);

      setCurrentStatus({
        currentModule: moduleId,
        currentLesson: lessonId
      });

      // Auto-select module and lesson in the dropdowns
      setSelectedModule(moduleId ? moduleId.toString() : '');
      setSelectedLesson(lessonId ? lessonId.toString() : '');
    }).catch((error) => {
      console.error('Error fetching lesson activity profile data:', error);
      // Reset dropdowns on error
      setSelectedModule('');
      setSelectedLesson('');
    });
  };

  const handleModuleChange = (value, studentId) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId === studentId) {
        return {
          ...student,
          activeModule: parseInt(value),
        };
      }
      return student;
    });
    setStudentsData(updatedStudentData);
  };

  const handleLessonChange = (value, studentId) => {
    const updatedStudentData = studentsData.map((student) => {
      if (student.studentId === studentId) {
        return {
          ...student,
          activeLesson: parseInt(value),
        };
      }
      return student;
    });
    setStudentsData(updatedStudentData);
  };

  const saveStudentModule = (userId, moduleId) => {
    const apiUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveModule`;
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${userId}`)
      .then((response) => {
        const studentId = response.data.Student_id;
        const startDate = new Date().toISOString().split('T')[0];
        const data = {
          Module_id: moduleId,
          Student_id: studentId,
          StartDate: startDate,
          EndDate: null,
          Score: 0,
          Complete: 0,
        };
        axios
          .post(apiUrl, data)
          .then((response) => {
            console.log('Module saved successfully:', response.data);
          })
          .catch((error) => {
            console.error('Error saving module:', error);
          });
      })
      .catch((error) => {
        console.error('Error fetching student ID:', error);
      });
  };

  const saveStudentLesson = (userId, lessonId) => {
    const apiUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveLesson`;
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${userId}`)
      .then((response) => {
        const studentId = response.data.Student_id;
        const startDate = new Date().toISOString().split('T')[0];
        const data = {
          Lesson_id: lessonId,
          Student_id: studentId,
          StartDate: startDate,
          EndDate: null,
          Complete: 0,
        };
        axios
          .post(apiUrl, data)
          .then((response) => {
            console.log('Lesson saved successfully:', response.data);
          })
          .catch((error) => {
            console.error('Error saving lesson:', error);
          });
      })
      .catch((error) => {
        console.error('Error fetching student ID:', error);
      });
  };

  const saveStudentModuleProjectAssignment = (userId, moduleId) => {
    const apiUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveStudentModuleProjectAssignments`;
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${userId}`)
      .then((response) => {
        const studentId = response.data.Student_id;
        const currentDate = new Date();
        const submissionDate = new Date(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));
        const data = {
          Module_id: moduleId,
          Student_id: studentId,
          SubmissionDate: submissionDate.toISOString().split('T')[0],
        };
        axios
          .post(apiUrl, data)
          .then((response) => {
            console.log('Module project assignment saved successfully:', response.data);
          })
          .catch((error) => {
            console.error('Error saving module project assignment:', error);
          });
      });
  };

  const saveStudentLessonProjectAssignment = (userId, lessonId) => {
    const apiUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveStudentLessonProjectAssignments`;
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${userId}`)
      .then((response) => {
        const studentId = response.data.Student_id;
        const currentDate = new Date();
        const submissionDate = new Date(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));
        const data = {
          Lesson_id: lessonId,
          Student_id: studentId,
          SubmissionDate: submissionDate.toISOString().split('T')[0],
        };
        axios
          .post(apiUrl, data)
          .then((response) => {
            console.log('Lesson project assignment saved successfully:', response.data);
          })
          .catch((error) => {
            console.error('Error saving lesson project assignment:', error);
          });
      });
  };

  const saveStudentLessonActivities = (userId, lessonId) => {
    const apiUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveStudentLessonActivities`;
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${userId}`)
      .then((response) => {
        const studentId = response.data.Student_id;
        const data = {
          Lesson_id: lessonId,
          Student_id: studentId,
        };
        axios
          .post(apiUrl, data)
          .then((response) => {
            console.log('Student Lesson Activities saved successfully:', response.data);
          })
          .catch((error) => {
            console.error('Error saving Student Lesson Activities:', error);
          });
      });
  };

  const handleSave = (studentId) => {
    const saveStudentData = studentsData?.filter((student) => (
      student.studentId === studentId
    ));
    const saveData = saveStudentData?.[0];

    if (!saveData["activeCourse"] || !saveData["activeModule"] || !saveData["activeLesson"]) {
      toast.error('Please select a course, module, and lesson.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    const data = {
      user_id: saveData?.id,
      course_id: saveData["activeCourse"],
      module_id: saveData["activeModule"],
      lesson_id: saveData["activeLesson"],
    };

    axios
      .post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveUserCurrentStatus`, data)
      .then((response) => {
        toast.success('Data saved successfully.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error('Error saving data:', error);
        toast.error('Error saving data.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      });

    saveStudentLesson(saveData?.id, saveData["activeLesson"]);
    saveStudentModule(saveData?.id, saveData["activeModule"]);
    saveStudentModuleProjectAssignment(saveData?.id, saveData["activeModule"]);
    saveStudentLessonProjectAssignment(saveData?.id, saveData["activeLesson"]);
    saveStudentLessonActivities(saveData?.id, saveData["activeLesson"]);
  };

  const handleStudentSelect = (student) => {
    setSelectedStudent(student);
    setSelectedCourse(student.activeCourse ? student.activeCourse.toString() : '');
    setSelectedModule(student.activeModule ? student.activeModule.toString() : '');
    setSelectedLesson(student.activeLesson ? student.activeLesson.toString() : '');
  };


  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      }).then(response => {
        response.json().then(userInfo => {
          setUserInfo(userInfo);
          if (userInfo?.usertype) {
            const uType = userInfo?.usertype;
            setUserRole(uType);
          }
        })
          .catch(err => console.log("Error in useeffect:", err))
      });
    }
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const determineUserRole = (usertype) => {
    if (usertype === 'Student')
      return "Student";
    else if (usertype === 'Teacher')
      return "Teacher";
    else if (usertype === 'Admin')
      return "Admin";
    else
      return "guest";
  };

  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    setUserRole(userRole);
  };

  function onLogout() {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    setUserRole('guest');
    setTimeout(() => {
      navigate('/')
    }, 300);
  }

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return 'N/A';
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  const getStudentAvatar = (student) => {
    if (!student.avatar || student.avatar === '' || student.avatar === null) {
      const initials = student.name ? student.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'S';
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(student.name || 'Student')}&background=random&color=fff&size=40`;
    }

    let avatarUrl = student.avatar;

    if (avatarUrl.startsWith('//')) {
      avatarUrl = `https:${avatarUrl}`;
    } else if (avatarUrl.startsWith('/')) {
      avatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${avatarUrl.substring(1)}`;
    } else if (!avatarUrl.startsWith('http')) {
      avatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${avatarUrl}`;
    }

    return avatarUrl;
  };

  const handleImageError = (e) => {
    const studentName = e.target.alt || 'Student';
    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(studentName)}&background=random&color=fff&size=40`;
    e.target.onerror = null;
  };

  const filteredStudents = studentsData.filter(student =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.parentname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && (
        <>
          {isGuest && <GuestNav onLogin={onLogin} />}
        </>
      )}

      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>Student Dashboard</h1>
          <div className="user-info">
            <span className="user-greeting">Hi, {username || 'Saiful'}</span>
            <div className="user-avatar">
              <img src={_avatar_ || "/api/placeholder/32/32"} alt="User" />
            </div>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="students-section">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search Student"
                className="search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {/* <button className="search-button">🔍</button> */}
            </div>

            <div className="students-list">
              {filteredStudents.map((student) => (
                <div
                  key={student.studentId}
                  className={`student-item ${selectedStudent?.studentId === student.studentId ? 'selected' : ''}`}
                  onClick={() => handleStudentSelect(student)}
                >
                  <div className="student-avatar">
                    <img
                      src={getStudentAvatar(student)}
                      alt={student.name}
                      onError={handleImageError}
                      style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                    />
                  </div>
                  <div className="student-info">
                    <div className="student-name">
                      <strong>Student: </strong>{student.name}
                    </div>
                    <div className="parent-name">
                      <strong>Parent Name: </strong>{student.parentname}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="details-section">
            {selectedStudent ? (
              <>
                <div className="student-details-card">
                  <div className="student-profile">
                    <div className="profile-avatar">
                      <img
                        src={getStudentAvatar(selectedStudent)}
                        alt={selectedStudent.name}
                        onError={handleImageError}
                        style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="profile-info">
                      <div className="profile-field">
                        <strong>Student: </strong>{selectedStudent.name}
                      </div>
                      <div className="profile-field">
                        <strong>Parent Name: </strong>{selectedStudent.parentname}
                      </div>
                      {/* <div className="profile-field">
                        <strong>📞 </strong>{selectedStudent.phonenumber || '+923012333846'}
                      </div>
                      <div className="profile-field">
                        <strong>✉️ </strong>{selectedStudent.email || 'ayesha@gmail.com'}
                      </div> */}
                      <div className="profile-field">
                        <strong>📅Age:  </strong>{calculateAge(selectedStudent.dateofbirth)} years
                      </div>
                    </div>
                  </div>


                  <div className="course-selection">
                    <div className="select-row">
                      <select
                        value={selectedCourse || ''}
                        onChange={(e) => {
                          const newCourse = e.target.value;
                          setSelectedCourse(newCourse);
                          setSelectedModule('');
                          setSelectedLesson('');
                          handleCourseChange(newCourse, selectedStudent.studentId);
                        }}
                        className="course-select"
                      >
                        <option value="">Select Course</option>
                        {courses?.map((course) => (
                          selectedStudent?.studentId == course?.Student_id && (
                            <option key={course?.Course_id} value={course?.Course_id}>
                              {course?.coursename}
                            </option>
                          )
                        ))}
                      </select>

                      <select
                        value={selectedModule || ''}
                        onChange={(e) => {
                          const newModule = e.target.value;
                          setSelectedModule(newModule);
                          setSelectedLesson('');
                          handleModuleChange(newModule, selectedStudent.studentId);
                        }}
                        className="course-select"
                        disabled={!selectedCourse}
                      >
                        <option value="">Select Module</option>
                        {modules?.map((module) => (
                          selectedCourse == module?.Course_id && (
                            <option key={module.Module_id} value={module.Module_id}>
                              {module.modulename}
                            </option>
                          )
                        ))}
                      </select>
                    </div>

                    <div className="select-row">
                      <select
                        value={selectedLesson || ''}
                        onChange={(e) => {
                          const newLesson = e.target.value;
                          setSelectedLesson(newLesson);
                          handleLessonChange(newLesson, selectedStudent.studentId);
                        }}
                        className="course-select"
                        disabled={!selectedModule}
                      >
                        <option value="">Select Lesson</option>
                        {lessons?.map((lesson) => (
                          selectedModule == lesson.Module_id && (
                            <option key={lesson.Lesson_id} value={lesson.Lesson_id}>
                              {lesson.lessonName}
                            </option>
                          )
                        ))}
                      </select>

                      <button
                        className="save-button"
                        onClick={() => {
                          handleSave(selectedStudent.studentId);
                          // Update dropdown state after save
                          setSelectedCourse('');
                          setSelectedModule('');
                          setSelectedLesson('');
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>

                </div>

                <div className="progress-section">
                  <div className="progress-header">
                    <h3>Check Progress</h3>

                    <Link to='/StudentProgress' state={{ studentName: selectedStudent?.name, studentId: selectedStudent.studentId, courseId: selectedCourse }}>
                      <button className="course-select small">View Progress</button>
                    </Link>
                  </div>


                </div>
              </>
            ) : (
              <div className="no-student-selected">
                <p>Select a student to view details</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default StudentDashboard;